// FILECONTENT_START src/common/components/Inputs/TextField/index.ts
import TextField from "./TextField";
export default TextField;
export type { TextFieldProps } from "./TextField";

// FILECONTENT_END src/common/components/Inputs/TextField/index.ts